import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.sass']
})
export class LandingPageComponent implements OnInit {

  token: string;
  vendor: string;

  unsubscribeSubject = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

    route.queryParams.pipe(takeUntil(this.unsubscribeSubject)).subscribe(queryParams => {
      route.params.pipe(takeUntil(this.unsubscribeSubject)).subscribe(params => {
        this.token = queryParams.token;
        this.vendor = params.cloudVendor;
      });
    });
   }

  ngOnInit(): void {
  }

  goToRegistration(subscriptionType: string) {

    if (subscriptionType === 'Free Trial') {
      this.router.navigate([environment.api.routes.subscription_create + this.vendor], {
        relativeTo: this.route,
        queryParams: {
          token: this.token,
          type: 'free'
        },
        queryParamsHandling: 'merge'
      });
    } else if (subscriptionType === 'Paid Subscription') {
      this.router.navigate([environment.api.routes.subscription_create + this.vendor], {
        relativeTo: this.route,
        queryParams: {
          token: this.token,
          type: 'paid'
        },
        queryParamsHandling: 'merge'
      });
    }

  }
}